<template>
  <div class="collapsibleFormInputContainer">
    <el-tabs v-model="nameTab"
             @tab-click="handleTab">
      <el-tab-pane label="CREAR AREA DE PRIORIDAD" name="createZone">
        <div class="block">
          <el-form class="form-map-main"
                   ref="formCreate">
            <el-form-item label="NOMBRE"
                          prop="zoneName">
              <el-input v-model="form.zoneName" @input="validateName"
                        placeholder="Nombre zona" maxlength="64"
                        show-word-limit/>
            </el-form-item>
            <div v-show="errorsForm.zoneName != ''">
                <span class="alertForm">
                  <i class="el-icon-warning-outline"></i>
                  &#160; {{errorsForm.zoneName}}
                </span>
            </div>
            <p></p>
            <el-form-item label="INDICE DE PRIORIDAD">
              <el-input v-model.number="form.numPriority"
                        @input="validatePriority(form.numPriority)"
                        type="number"
                        :min="1"
                        placeholder="Ingrese un valor númerico de prioridad"/>
              <div v-show="form.numPriority === ''">
                <span class="alertForm">
                  <i class="el-icon-warning-outline"></i>
                  &#160; {{errorsForm.numPriority}}
                </span>
              </div>
            </el-form-item>
            <el-form-item label="REGIÓN">
              <BaseSelectRegion @sendRegion="receiveRegionId">
              </BaseSelectRegion>
              <div v-show="errorsForm.selectRegion != ''">
                <span class="alertForm">
                  <i class="el-icon-warning-outline"></i>
                  &#160; {{errorsForm.selectRegion}}
                </span>
              </div>
            </el-form-item>
          </el-form>
          <el-row :gutter=37>
            <el-col :span=13>
              <el-button class="primary colorBtnDraw parpadeo"
                         size="mini"
                         @click="addPoligon">
                <i class="el-icon-edit"></i>DIBUJAR ZONA
              </el-button>
            </el-col>
            <el-col :span=11>
              <div v-show="showAddZone">
                <el-button v-if="loadCreateZone"
                           type="text"
                           class="primary"
                           size="mini">
                  <i class="el-icon-loading"></i>&#160;&#160;&#160;CREANDO ZONA
                </el-button>
                <el-button v-else
                           class="colorBtn primary"
                           size="mini"
                           @click="clickSendZone">CREAR ZONA PRIORIDAD
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="GESTIÓN ZONA" name="editZone">
        <el-button type="text" v-if="loadingTable" class="primary" size="mini">
          <i class="el-icon-loading"></i>&#160;&#160;&#160;CARGANDO
        </el-button>
        <el-table
          :data="dataZones"
          style="width: 100%"
          size="mini"
          max-height="300">
          <el-table-column
            prop="name"
            label="NOMBRE"
            min-width="90">
          </el-table-column>
          <el-table-column
            prop="priority_index"
            label="ÍNDICE"
            min-width="40">
          </el-table-column>
          <el-table-column
            label="ESTADO"
            min-width="40">
            <el-switch
              slot-scope="scope"
              @change="changeStatus(scope.row)"
              style="height: 18px; width: 30px;"
              v-model="scope.row.active"
              active-color="#AAD500"
              inactive-color="#a5a5a5">
            </el-switch>
          </el-table-column>
          <el-table-column
            min-width="20">
            <el-button
              slot-scope="scope"
              type="text"
              style="color: #F5A623"
              icon="el-icon-delete"
              @click="deleteZone(scope.row)">
            </el-button>
          </el-table-column>
          <el-table-column
            min-width="30">
            <el-button
              slot-scope="scope"
              size="mini"
              type="text"
              style="color: #AAD500"
              @click="showZone(scope)">
              <span style="font-size: 12px;">VER</span>
            </el-button>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane v-if="showDetail === true" label="DETALLE ZONA" name="detail">
        <el-row>
          <el-col :span=24>
            <div class="windowsCreated">
              <p class="titleWindowsListDetail">NOMBRE ÁREA
                <span style= "margin-left: 62px; color: #AAD500">{{restrictionsName}}</span>
              </p>
              <p class="titleWindowsListDetail">REGIÓN
                <span style= "margin-left: 101px; color: #AAD500">
                  {{restrictionsRegion | regionsFormat}}</span>
              </p>
              <p class="titleWindowsListDetail">INDICE DE PRIORIDAD
                <span style= "margin-left: 20px; color: #AAD500">{{indexPriority}}</span></p>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';
import BaseSelectRegion from './BaseSelectRegion.vue';

export default {
  name: 'ZonesFormPriority',
  components: {
    BaseSelectRegion,
  },
  data() {
    return {
      // todo: Ver por localidades, utilizar búscador google maps
      regionCords: [
        {
          id: 1, // Tarapaca OK
          lng: -69.808079,
          lat: -20.200882,
          zoom: 8,
        },
        {
          id: 2, // Antofagasta OK
          lng: -70.394431,
          lat: -23.627096,
          zoom: 7,
        },
        {
          id: 3, // Atacama OK
          lng: -70.612726,
          lat: -27.046011,
          zoom: 7,
        },
        {
          id: 4, // Coquimbo OK
          lng: -71.338516,
          lat: -29.961246,
          zoom: 9,
        },
        {
          id: 5, // Valpo OK
          lng: -71.635253,
          lat: -33.031276,
          zoom: 12,
        },
        {
          id: 6, // L B O'higgins OK
          lng: -71.826346,
          lat: -34.363218,
          zoom: 10,
        },
        {
          id: 7, // Maule OK
          lng: -72.356081,
          lat: -35.415902,
          zoom: 8,
        },
        {
          id: 8, // Biobio OK
          lng: -73.197049,
          lat: -37.212972,
          zoom: 10,
        },
        {
          id: 9, // Araucanía OK
          lng: -73.241713,
          lat: -38.744875,
          zoom: 8,
        },
        {
          id: 10, // Los Lagos OK
          lng: -73.572665,
          lat: -40.71588,
          zoom: 8,
        },
        {
          id: 11, // Aysén OK
          lng: -74.089966,
          lat: -46.375856,
          zoom: 7,
        },
        {
          id: 12, // Magallanes OK
          lng: -72.599954,
          lat: -53.133935,
          zoom: 7,
        },
        {
          id: 13, // RM OK
          lng: -70.818046,
          lat: -33.471274,
          zoom: 9,
        },
        {
          id: 14, // Los Ríos
          lng: -73.167895,
          lat: -39.759730,
          zoom: 9,
        },
        {
          id: 15, // Arica y Parinacota OK
          lng: -70.054344,
          lat: -18.677916,
          zoom: 9,
        },
        {
          id: 16, // Todo: Falta Regíon Ñuble en base de datos
          lng: -72.5072355,
          lat: -36.6020576,
          zoom: 9,
        },
      ],
      days: [
        {
          label: 'Lunes',
          value: 1,
        },
        {
          label: 'Martes',
          value: 2,
        },
        {
          label: 'Miércoles',
          value: 3,
        },
        {
          label: 'Jueves',
          value: 4,
        },
        {
          label: 'Viernes',
          value: 5,
        },
        {
          label: 'Sábado',
          value: 6,
        },
        {
          label: 'Domingo',
          value: 7,
        },
      ],
      form: {
        zoneName: '',
        selected: [],
        selectRegion: '',
        numPriority: null,
      },
      dataZones: [],
      dialogVisible: false,
      timeWindows: [],
      regionId: 0,
      props: {
        polygon: {
          type: String,
          required: true,
        },
      },
      nameTab: 'createZone',
      showDetail: false,
      errorsForm: {
        zoneName: '',
        select: '',
        numPriority: '',
        selected: '',
        selectRegion: '',
      },
      loadCreateZone: false,
      showAddZone: false,
      loadingTable: false,
      restrictionsDetail: [],
      restrictionsName: '',
      restrictionsRegion: '',
    };
  },
  filters: {
    daysFormat(id) {
      const days = ['', 'L', 'M', 'MI', 'J', 'V', 'S', 'D'];
      const result = [];
      if (id.length > 0) {
        id.forEach((e) => {
          result.push(days[e.id]);
        });
      } else {
        for (let i = 1; i < 8; i += 1) {
          result.push(days[i]);
        }
      }
      return result.join('-');
    },
    regionsFormat(id) {
      const regions = ['', 'Tarapacá', 'Antofagasta', 'Atacama',
        'Coquimbo', 'Valparaíso', 'Libertador General Bernardo O’Higgins',
        'Maule', 'Biobío', 'La Araucanía', 'Los Lagos', 'Aysén del General Carlos Ibáñez del Campo',
        'Magallanes y la Antártica Chilena', 'Metropolitana de Santiago',
        'Los Ríos', 'Arica y Parinacota', 'Ñuble'];
      const result = regions[id];
      return result;
    },
    dateFormat(date) {
      return moment.utc(date).format('LT');
    },
  },
  methods: {
    showZone(data) {
      this.$emit('submit', data.row.polygon);
      this.showDetail = true;
      this.nameTab = 'detail';
      this.restrictionsName = data.row.name;
      this.restrictionsRegion = data.row.regions_id;
      this.indexPriority = data.row.priority_index;
    },
    handleTab(tab) {
      if (tab.name === 'editZone' || tab.name === 'createZone') {
        this.showDetail = false;
      }
      if (tab.name === 'createZone') {
        this.$emit('cleanPoly');
      }
      if (tab.name === 'createZone' || tab.name === 'editZone') {
        this.restrictionsDetail = [];
        this.restrictionsName = '';
        this.restrictionsRegion = '';
      }
    },
    changeStatus(row) {
      this.$message({
        message: `Cambiando estado de restricción, Nombre: ${row.name}`,
        duration: 8000,
        showClose: true,
      });
      apiRequest({
        module: 'crud',
        service: 'change_status_priority',
        params: {
          name: row.name,
          polygon: row.polygon,
          regions_id: row.regions_id,
          active: row.active,
        },
        pathparam: {
          id: row.id,
        },
      }).then((data) => {
        this.$notify({
          type: 'success',
          title: 'OK',
          message: `Estado modificado de restricción ${row.name}`,
        });
        this.getPriority({ limit: 100 });
        this.dataZones = data.data;
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Error al cambiar el estado de la zona.',
        });
      });
    },
    deleteZone(row) {
      this.$message({
        message: `Eliminando restricción, ${row.name}`,
        duration: 8000,
        showClose: true,
      });
      apiRequest({
        module: 'crud',
        service: 'delete_priority',
        pathparam: {
          id: row.id,
        },
      }).then((data) => {
        this.$notify({
          type: 'success',
          title: 'OK',
          message: `Restricción ${row.name} eliminada`,
        });
        this.getPriority({ limit: 100 });
        this.$emit('cleanPoly');
        this.dataZones = data.data;
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Error al eliminar la zona.',
        });
      });
    },
    receiveTimeWindows(data) {
      this.timeWindows.push(data);
    },
    deletePolyMap() {
      this.$emit('cleanPoly');
    },
    receiveRegionId(data) {
      this.regionId = data;
      if (this.regionId === -1) {
        this.errorsForm.selectRegion = 'Región requerida';
      } else {
        this.errorsForm.selectRegion = '';
        const dataRegion = this.regionCords.find(e => e.id === this.regionId);
        if (dataRegion.length === 0) {
          this.$emit('centerMap', -70.6200875, -33.4715608, 8);
        } else {
          this.$emit('centerMap', dataRegion.lng, dataRegion.lat, dataRegion.zoom);
        }
      }
      this.form.selectRegion = data;
    },
    getPriority() {
      this.loadingTable = true;
      apiRequest({
        module: 'crud',
        service: 'get_priority',
        params: { limit: 100 },
      }).then((data) => {
        this.dataZones = data.data;
        this.loadingTable = false;
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Error al crear la zona.',
        });
        this.loadingTable = false;
      });
    },
    // FORM
    addPoligon() {
      if (this.form.zoneName === '' || this.form.numPriority === null || this.form.selectRegion === '') {
        this.alertForm();
        this.$notify({
          title: 'Advertencia',
          message: 'El formulario no puede tener campos vacíos',
          type: 'warning',
        });
      } else {
        this.$emit('addPoligon', true);
        this.showAddZone = true;
      }
    },
    validateName() {
      if (this.form.zoneName.trim() === '') {
        this.errorsForm.zoneName = 'Nombre zona requerido';
      } else {
        this.errorsForm.zoneName = '';
      }
    },
    validatePriority() {
      if (this.form.numPriority === '') {
        this.errorsForm.numPriority = 'Número de prioridad requerido';
      } else {
        this.errorsForm.numPriority = '';
      }
    },
    deleteWindows(i) {
      this.timeWindows.splice(i, 1);
    },
    changeOptionDay() {
      this.form.selected = [];
    },
    submit() {
      // eslint-disable-next-line
      if (this.form.zoneName === '' || this.form.numPriority === null || this.form.selectRegion === '') {
        this.alertForm();
        this.$notify({
          title: 'Advertencia',
          message: 'El formulario no puede tener campos vacíos',
          type: 'warning',
        });
      } else {
        // this.loadingCreateWindows = true;
        // this.checkTimeWindows();
      }
    },
    alertForm() {
      this.errorsForm.zoneName = (this.form.zoneName === '') ? 'Nombre zona requerido' : '';
      this.errorsForm.selectRegion = (this.form.selectRegion === '') ? 'Región requerida' : '';
      // eslint-disable-next-line
      this.errorsForm.numPriority = (this.form.numPriority === '') ? 'Número de prioridad requerida' : '';
    },
    cleanForm(type) {
      if (type === 'after create zone') {
        this.form.zoneName = '';
        this.form.select = [];
        this.form.numPriority = null;
        this.dataZones = [];
      }
    },
    // ENVIAR ZONA
    clickSendZone() {
      this.$emit('clickSendZone');
    },
    sendZone(data) {
      if (data === '' || data === null) {
        this.$notify({
          type: 'warning',
          title: 'Error',
          message: 'Debe dibujar la zona de restricción',
        });
      } else {
        this.loadCreateZone = true;
        apiRequest({
          module: 'crud',
          service: 'add_priority',
          params: {
            name: this.form.zoneName,
            priority_index: this.form.numPriority,
            polygon: data,
            regions_id: this.regionId,
            active: true,
          },
        }).then(() => {
          this.$emit('cleanPoly');
          this.$notify({
            title: 'Completado',
            message: 'Prioridad agregada con éxito.',
            type: 'success',
          });
          this.loadCreateZone = false;
          this.getPriority({ limit: 100 });
          this.cleanForm('after create zone');
          this.showAddZone = false;
        }).catch(() => {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: 'Error al crear la zona',
          });
          this.loadCreateZone = false;
        });
      }
    },
  },
  created() {
    this.getPriority({ limit: 100 });
  },
};
</script>

<style lang="scss" scoped>
  .colorBtn {
    background-color: $fb-green !important;
    border-color: $fb-green !important;
    color: #FFFFFF !important;
    border-radius: 0 !important;
    &:hover {
      background-color: $fb-green-dark-10 !important;
      color: #FFFFFF !important;
    }
  }
  .colorBtnDraw {
    background-color: $fb-green-dark-10 !important;
    border-color: $fb-green !important;
    color: white !important;
    border-radius: 0 !important;
    &:hover {
      background-color: $fb-green !important;
      color: white !important;
    }
  }
  .parpadeo {
    animation-name: parpadeo;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    -webkit-animation-name:parpadeo;
    -webkit-animation-duration: 3s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
  }
  @-moz-keyframes parpadeo{
    0% { opacity: 1.0; }
    50% { opacity: 0.0; }
    80% { opacity: 1.0; }
  }
  @-webkit-keyframes parpadeo {
    0% { opacity: 1.0; }
    50% { opacity: 0.0; }
    80% { opacity: 1.0; }
  }
  @keyframes parpadeo {
    0% { opacity: 1.0; }
    50% { opacity: 0.0; }
    80% { opacity: 1.0; }
  }
  .collapsibleFormInputContainer {
   padding: 0px;
  }
  .btn.primary {
    float: right;
    margin-top: 1em;
  }
  .form-map-title{
    color: #707070;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 12px;
  }
  button.el-button.plus {
    border-radius: 20px !important;
    background-color: $fb-green !important;
    border: none;
    margin-left: 1em;
  }
  .el-form.form-map-main .el-form-item:first-child {
    margin-bottom: 0;
  }
  .el-form-item.time-windows {
    display: flex;
    align-content: center;
    color: $fb-green;
  }
  .el-form-item.time-windows span {
    text-transform: uppercase;
    font-size: 10px!important;
    font-family: "Lato", sans-serif;
    font-weight: bold;
    margin-right: 1em;
  }
  .el-form-item.time-windows button {
    background-color: $fb-green;
    border: transparent;
    color: $fb-grey-light-97;
    &:focus {
      outline: none;
    }
    &:hover {
      background-color: $fb-green-dark-10;
    }
  }
  .el-dialog {
    z-index: 9999!important;
  }
  .alertForm {
    color: rgb(255, 145, 0);
    font-size: 12px;
  }
  .windowsCreated {
    padding: 0px;
    margin: 0px;
  }
  .windowsList {
    color: #9B9B9B;
    font-size: 12px;
    padding: 0;
  }
  .titleWindowsList {
    color: #AAD500;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 600;
    padding: 0;
    margin: 0;
  }
  .titleWindowsListDetail {
    color: #9B9B9B;
    text-transform: uppercase;
    font-size: 12px;
    padding: 0;
    margin-top: 5px;
  }
  .titleWindows{
    color: #AAD500;
    text-transform: uppercase;
    font-size: 14px;
  }
</style>
